import { render, staticRenderFns } from "./FacilityPaymentSettingsV2.vue?vue&type=template&id=35d938ec&scoped=true&"
import script from "./FacilityPaymentSettingsV2.vue?vue&type=script&lang=ts&"
export * from "./FacilityPaymentSettingsV2.vue?vue&type=script&lang=ts&"
import style0 from "./FacilityPaymentSettingsV2.vue?vue&type=style&index=0&id=35d938ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d938ec",
  null
  
)

export default component.exports